import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { ReactNode } from 'react'

if (typeof window !== 'undefined' && import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY as string, {
    api_host: `${window.location.origin}/ingest`, // reverse proxy to posthog in vercel.json
    ui_host: import.meta.env.VITE_POSTHOG_HOST as string,
    capture_pageview: false, // manually track pageviews
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
        // color: false,
        // date: false,
        // 'datetime-local': false,
        email: true,
        // month: false,
        // number: false,
        // range: false,
        // search: false,
        // tel: false,
        // text: false,
        // time: false,
        // url: false,
        // week: false,
        // textarea: true,
        // select: false,
      }
    }
  })
}

export function PHProvider({ children }: { children: ReactNode }) {
  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  )
} 